import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MessagesStatus, MessagesTitles } from 'app/models/messages';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-listado-sector',
  templateUrl: './listado-sector.component.html',
  styleUrls: ['./listado-sector.component.scss'],
  providers:[MessagesTitles, MessagesStatus]
})
export class ListadoSectorComponent implements OnInit {
  pageSizeOptions = [10, 20, 30, 50, 100, 200];
  loading: boolean;
  sectores:any = [];
  dataSource: any;
  abrirAgregarSector : boolean;
  user:any;
  dataArray:any={} ;
  rucProvFilter = new FormControl('');
  filterValues = {
    Nombre_Sector: ''
    };  
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;  
  displayedColumns: string[] = 
            ['checked','IDSector','Nombre','Estado','AltaFecha'];
  constructor(private riesgo:RiesgoService,private msgStatus:MessagesStatus, private msgTitulos : MessagesTitles) { 
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
  } 

  ngOnInit() {
    this.ListarSectores("");

    this.rucProvFilter.valueChanges
    .subscribe(
      Nombre_Sector => {
        this.filterValues.Nombre_Sector = Nombre_Sector;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

  }

  createFilter(): (data: any, filter: string) => boolean {
    return function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.Nombre_Sector.toString().toLowerCase().indexOf(searchTerms.Nombre_Sector) !== -1;
    }
  }

  nuevoSector(){
    this.riesgo.dataSector = "";
    this.abrirAgregarSector = true;
  }

  CerrarPopUpSector(){   
    this.abrirAgregarSector = false;
    this.ListarSectores("") 
  }

  ListarSectores(estado){
    this.loading = true;
    this.riesgo.obtenerSectoresEconomicos().subscribe(
      res=>{
        this.sectores=res;
        if(estado!= ""){
          this.sectores=this.sectores.filter(est => est.Estado == estado);
        }        
        this.dataSource = new MatTableDataSource(this.sectores);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
        this.loading = false; 
      }        
    )      
  }

  BajaSector(data){
    Swal.fire({
      title: '¿Estás seguro de dar de baja al sector '+data.Nombre_Sector+ ' ?',
      text: "Esta acción no se podrá revertir.",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
    this.loading = true
    this.dataArray.Estado="I";
    this.dataArray.Usuario=this.user.Usuario;  
    this.riesgo.ActualizarSector(this.dataArray,data.idSector).subscribe(
      res=>{
        this.loading = false;
        Swal.fire({
          title: "¡Éxito!",
          text: 'Sector dado de baja correctamente.',
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then( resp => {
          if (resp.value == true){              
            this.ListarSectores("");
          }
        }) 
      },(err: HttpErrorResponse)=> {
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
      } else {
        this.msgStatus.getMessage(err.status);            
      }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "El sector no fue dada de baja . "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      })
    
  } else if (result.dismiss === Swal.DismissReason.cancel) {
    this.loading= false;
  }
})

}
  
FiltroEstado(estado){  
  this.ListarSectores(estado);       
}

  editarSector(element){    
    this.riesgo.dataSector = element;
    this.abrirAgregarSector = true;
  }

}
